import React from 'react';
import { Link } from 'react-router-dom';
import linkedinLogo from '../../assets/linkedin.png';

const Footer = () => {
  const footerLinks = [
    {
      title: "Légal",
      links: [
        { to: "/privacy-policy", text: "Politique de confidentialité", icon: "shield" },
        { to: "/terms-of-service", text: "Conditions générales", icon: "document" },
        { to: "/terms-of-use", text: "Politique d'utilisation", icon: "refresh" },
        { to: "/legal-notice", text: "Mentions légales", icon: "info" }
      ]
    },
    {
      title: "Contact",
      links: [
        { to: "mailto:raouf@clicdroits.info", text: "raouf@clicdroits.info", icon: "mail" },
       
      ]
    },
    {
      title: "Ressources",
      links: [
        { to: "/blog", text: "Blog", icon: "pencil" },
        { to: "/faq", text: "FAQ", icon: "question" }
      ]
    }
  ];

  const renderIcon = (iconName) => {
    const icons = {
      shield: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 2a1 1 0 00-1 1v1a1 1 0 002 0V3a1 1 0 00-1-1zM4 4h3a3 3 0 006 0h3a2 2 0 012 2v9a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2z" clipRule="evenodd" />
        </svg>
      ),
      document: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clipRule="evenodd" />
        </svg>
      ),
      refresh: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1z" clipRule="evenodd" />
        </svg>
      ),
      info: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
        </svg>
      ),
      mail: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
          <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
        </svg>
      ),
      phone: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
          <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
        </svg>
      ),
      pencil: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
          <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
          <path fillRule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clipRule="evenodd" />
        </svg>
      ),
      question: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
        </svg>
      )
    };
    return icons[iconName] || null;
  };

  return (
    <footer className="bg-gradient-to-b from-primary to-primary/95 text-white relative" aria-labelledby="footer-heading">
      <div className="absolute inset-0 pointer-events-none">
        {/* You may have decorative elements here - all are now non-interactive */}
      </div>
      
      <h2 id="footer-heading" className="sr-only">Footer</h2>
      
      <div className="container mx-auto px-4 py-12 relative z-10">
        <div className="max-w-7xl mx-auto">
          {/* Main footer content */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {footerLinks.map((section, index) => (
              <div key={index} className="space-y-4">
                <h3 className="text-lg font-semibold mb-4 text-white/90">{section.title}</h3>
                <ul className="space-y-3">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <Link 
                        to={link.to}
                        className="group flex items-center space-x-2 text-white/80 hover:text-white transition-all duration-300"
                      >
                        <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-white/10 group-hover:bg-white/20 transition-all duration-300">
                          {renderIcon(link.icon)}
                        </span>
                        <span className="text-sm group-hover:translate-x-1 transition-transform duration-300">
                          {link.text}
                        </span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Divider with gradient */}
          <div className="w-full h-px bg-gradient-to-r from-transparent via-white/20 to-transparent mb-8"></div>

          {/* Bottom section with company info and social */}
          <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
            {/* Company info */}
            <div className="flex flex-col items-center md:items-start space-y-2">
              <div className="flex items-center space-x-2">
                <span className="font-medium text-lg">clicdroits.info</span>
                <span className="text-white/60">•</span>
                <span className="text-sm text-white/80">© {new Date().getFullYear()}</span>
              </div>
              <p className="text-sm text-white/60">
                Tous droits réservés
              </p>
            </div>
            
            {/* Creator info and social */}
            <div className="flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-4">
              <span className="text-sm text-white/80 text-center sm:text-left">
                Crée par Raouf K., assistant juridique en droit familial
              </span>
              <a 
                href="https://www.linkedin.com/in/raouf-k-405b631b1/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="group flex items-center justify-center w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 transition-all duration-300"
                aria-label="Visitez mon profil LinkedIn"
              >
                <img 
                  src={linkedinLogo} 
                  alt="LinkedIn"
                  className="w-5 h-5 group-hover:scale-110 transition-transform duration-300"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
